// extracted by mini-css-extract-plugin
export var overlay = "cookienotice-module--overlay--2MwBz";
export var container = "cookienotice-module--container--1Il6X";
export var cookieNoticeButtonsContainer = "cookienotice-module--cookieNoticeButtonsContainer--1WU4a";
export var text = "cookienotice-module--text--1rye7";
export var buttons_container = "cookienotice-module--buttons_container--2ZKC2";
export var checkboxIconContainer = "cookienotice-module--checkboxIconContainer--1lCEs";
export var checkboxIcon = "cookienotice-module--checkboxIcon--1G0dx";
export var error = "cookienotice-module--error--1N96m";